import React from 'react';
import { BarChart, Bar, LineChart, Line, PieChart, Pie, Cell, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { GroupedRow } from '../../utils/reportEngine';
import { ChartType } from '../../data/reports';
const PALETTE = ['#102a43', '#0e7490', '#B98723', '#627d98', '#06b6d4', '#9fb3c8', '#dcb668'];
const tooltipStyle = {
  fontSize: 12,
  borderRadius: 10,
  border: '1px solid #d9e2ec',
  background: '#ffffff',
  color: '#243b53',
  boxShadow: '0 8px 24px -12px rgba(16,42,67,0.18)'
};
interface ReportChartProps {
  data: GroupedRow[];
  chartType: ChartType;
  metricLabel: string;
}
export function ReportChart({
  data,
  chartType,
  metricLabel
}: ReportChartProps) {
  if (data.length === 0) {
    return <div className="flex h-72 items-center justify-center text-sm text-navy-400" data-id="element-222">
        No data matches the current filters.
      </div>;
  }
  if (chartType === 'pie') {
    return <div className="h-72 w-full" data-id="element-223">
        <ResponsiveContainer width="100%" height="100%" data-id="element-224">
          <PieChart data-id="element-225">
            <Pie data={data} dataKey="value" nameKey="group" innerRadius={58} outerRadius={95} paddingAngle={3} stroke="#ffffff" strokeWidth={2} data-id="element-226">
              {data.map((entry, i) => <Cell key={entry.group} fill={PALETTE[i % PALETTE.length]} data-id="element-227" />)}
            </Pie>
            <Tooltip formatter={(value: number) => [value, metricLabel]} contentStyle={tooltipStyle} data-id="element-228" />
            <Legend wrapperStyle={{
            fontSize: 12,
            color: '#627d98'
          }} data-id="element-229" />
          </PieChart>
        </ResponsiveContainer>
      </div>;
  }
  if (chartType === 'line') {
    return <div className="h-72 w-full" data-id="element-230">
        <ResponsiveContainer width="100%" height="100%" data-id="element-231">
          <LineChart data={data} margin={{
          top: 8,
          right: 16,
          left: -8,
          bottom: 4
        }} data-id="element-232">
            <CartesianGrid strokeDasharray="3 3" stroke="#e4eaf2" vertical={false} data-id="element-233" />
            <XAxis dataKey="group" tick={{
            fontSize: 11,
            fill: '#829ab1'
          }} tickLine={false} axisLine={{
            stroke: '#d9e2ec'
          }} data-id="element-234" />
            <YAxis tick={{
            fontSize: 11,
            fill: '#829ab1'
          }} tickLine={false} axisLine={false} data-id="element-235" />
            <Tooltip formatter={(value: number) => [value, metricLabel]} contentStyle={tooltipStyle} data-id="element-236" />
            <Line type="monotone" dataKey="value" stroke="#0e7490" strokeWidth={2} dot={{
            r: 3,
            fill: '#0e7490',
            strokeWidth: 0
          }} activeDot={{
            r: 5,
            fill: '#102a43'
          }} name={metricLabel} data-id="element-237" />
          </LineChart>
        </ResponsiveContainer>
      </div>;
  }
  return <div className="h-72 w-full" data-id="element-238">
      <ResponsiveContainer width="100%" height="100%" data-id="element-239">
        <BarChart data={data} margin={{
        top: 8,
        right: 16,
        left: -8,
        bottom: 4
      }} data-id="element-240">
          <CartesianGrid strokeDasharray="3 3" stroke="#e4eaf2" vertical={false} data-id="element-241" />
          <XAxis dataKey="group" tick={{
          fontSize: 11,
          fill: '#829ab1'
        }} tickLine={false} axisLine={{
          stroke: '#d9e2ec'
        }} interval={0} data-id="element-242" />
          <YAxis tick={{
          fontSize: 11,
          fill: '#829ab1'
        }} tickLine={false} axisLine={false} data-id="element-243" />
          <Tooltip formatter={(value: number) => [value, metricLabel]} cursor={{
          fill: '#f0f4f8'
        }} contentStyle={tooltipStyle} data-id="element-244" />
          <Bar dataKey="value" name={metricLabel} radius={[6, 6, 0, 0]} maxBarSize={44} data-id="element-245">
            {data.map((entry, i) => <Cell key={entry.group} fill={PALETTE[i % PALETTE.length]} data-id="element-246" />)}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>;
}